module.exports = __webpack_public_path__ + "img/user-avatar-1.98f527e5.png";